import { Moment } from 'moment';

type IDate = Moment | null | undefined;

export const DateUtils = {
  getNumOfDays: (start: IDate, end: IDate) => {
    if (!start) return 0;
    if (!end) return 1;
    return end.diff(start, 'day');
  }
};
